<template lang="pug">
  #login-page
    #site-title
      icon(data="~@/assets/svg/logo.svg" width="96" height="96" :fill="false" color="#DF5F2C")

      h1 OpenLikes

    #tag-line Meet people who share your interests

    button#twitter-btn.social-btn.button(@click="twitterLogin")
      font-awesome-icon.social-icon(:icon="['fab', 'twitter']")
      span Connect with Twitter

    button#facebook-btn.social-btn.button(@click="facebookLogin")
      font-awesome-icon.social-icon(:icon="['fab', 'facebook-f']")
      span Connect with Facebook

    button#google-btn.social-btn.button(@click="googleLogin")
      .google-icon
        GoogleIcon
      span Connect with Google
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {
    twitterAuthUrl,
  },

  watch: {},

  methods: {
    facebookLogin,
    googleLogin,
    twitterLogin,
  },

  components: {
    GoogleIcon: require('@/components/icons/GoogleIcon').default,
  },
}

/* Computed ---------------------------------------------------- */
function twitterAuthUrl() {
  return `${process.env.VUE_APP_API_URL}/auth/twitter`
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function facebookLogin() {
  window.location = `${process.env.VUE_APP_API_URL}/auth/facebook`
}

function googleLogin() {
  this.$auth.oauth2('google', {
    params: {
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      redirect_uri: "https://openlikes.com/auth/callback",
      scope: 'profile email',
      state: {
        provider: 'google',
      },
    },
  })
}

function twitterLogin() {
  window.location = `${process.env.VUE_APP_API_URL}/auth/twitter`
}
</script>
